














































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

const DEFAULT_DATE = "";
@Component({
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: "setValue",
  },
})
export default class MonthPicker extends Vue {
  @Prop()
  readonly value: string;

  @Prop({ default: false })
  readonly outlined: boolean;

  @Prop({ default: false })
  readonly "hide-details": boolean;

  @Prop({ default: false })
  readonly dense: boolean;

  @Prop({ default: false })
  readonly "no-gutters": boolean;

  @Prop({ default: null })
  readonly label: string;

  @Prop({ default: "" })
  readonly placeholder: string;

  @Prop({ default: false })
  readonly clearable: boolean;

  @Prop({ default: null })
  readonly min: string;

  @Prop({ default: null })
  readonly max: string;

  @Prop({ default: () => [] })
  readonly rules: any;

  display = false;
  date = "";

  get formattedDate() {
    if (!this.value) return null;
    return moment(this.value, "YYYY-MM").format("MM.YYYY");
  }

  okHandler() {
    this.resetPicker();
    this.$emit("input", this.date);
  }
  resetPicker() {
    this.display = false;
  }
  clearHandler() {
    this.resetPicker();
    this.date = DEFAULT_DATE;
    this.$emit("input", undefined);
  }
  setValue(date: string) {
    this.date = date;
  }

  months: any = {
    kk: {
      "01": "Қаң",
      "02": "Ақп",
      "03": "Нау",
      "04": "Сәу",
      "05": "Мам",
      "06": "Мау",
      "07": "Шіл",
      "08": "Там",
      "09": "Қыр",
      "10": "Қаз",
      "11": "Қар",
      "12": "Жел",
    },
    ru: {
      "01": "Янв",
      "02": "Фев",
      "03": "Мар",
      "04": "Апр",
      "05": "Май",
      "06": "Июн",
      "07": "Июл",
      "08": "Авг",
      "09": "Сен",
      "10": "Окт",
      "11": "Ноя",
      "12": "Дек",
    },
  };

  getMonthFormat(isoDate: string) {
    return this.months[this.$i18n.locale][isoDate.substr(5)];
  }
}
